import { createContext, useContext } from 'react';
import type { BreadcrumbProps } from 'antd';

export type BreadcrumbItem = NonNullable<BreadcrumbProps['items']>[number];

interface BreadcrumbContextValue {
  items: BreadcrumbItem[] | null;
  setItems: (items: BreadcrumbItem[] | null) => void;
}

const BreadcrumbContext = createContext<BreadcrumbContextValue | undefined>(undefined);

export const BreadcrumbProvider = BreadcrumbContext.Provider;

// eslint-disable-next-line react-refresh/only-export-components
export const useBreadcrumb = (): BreadcrumbContextValue => {
  const ctx = useContext(BreadcrumbContext);
  if (!ctx) {
    throw new Error('useBreadcrumb must be used within a BreadcrumbProvider');
  }
  return ctx;
};


